import {Pipe, PipeTransform} from "@angular/core";
import {DatoPeriodeUtenTid} from "../tjenester/ressurser/generertNg2HttpKlient";
import {DatoPeriodeUtenTidFormatering} from "../tjenester/DatoPeriodeUtenTidFormatering";
import {lesDatoPeriodeUtenTid, PlainDatePeriode, PlainDatePeriodeMuligÅpenSlutt} from "felles-ng2/støttefunksjoner/plainDatePerioder";
import {PlainDateFormat} from "felles-ng2/tjenester/TemporalFormatering";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {erStreng} from "felles-ng2/støttefunksjoner/strenger";

/**
 * Formaterer {@link DatoPeriodeUtenTid} instanser.
 * Bruker format='short' som standard som gir følgende resultat: '11.07.2014 til 13.07.2014'.
 */
@Pipe({name: 'datoperiodeutentid', pure: true, standalone: true})
export class FormaterDatoPeriodeUtenTidPipe implements PipeTransform {
    constructor(private formatering: DatoPeriodeUtenTidFormatering) {
    }

    transform(periode: PlainDatePeriode | PlainDatePeriodeMuligÅpenSlutt | DatoPeriodeUtenTid | null, format: PlainDateFormat = 'short'): string {
        if (erNil(periode)) return '';
        return this.formatering.formaterMuligÅpenSlutt(
           erStreng(periode.start) ? lesDatoPeriodeUtenTid(periode as DatoPeriodeUtenTid) : periode as PlainDatePeriodeMuligÅpenSlutt,
          format);
    }
}
